export enum Currency {
    GOLD_COIN = 'GOLD_COIN',
    TOURNAMENT_POINTS = 'TOURNAMENT_POINTS',
}